import { ImageName } from "@mcleod/images";
import { DataSourceMode, Dialog, Layout } from "@mcleod/components";
import { UnassignPrompt } from "./UnassignPrompt";

export class UnassignDialog extends Dialog {
    private _codeType: string;
    private layout: UnassignPrompt

    constructor(codeType: string) {
        super({
            title: "Unassignment",
            minWidth: "500",
            okVisible: false,
            borderShadow: true,
            fillHeight: false,
            fillRow: false,
            panelTitleProps: {
                backgroundColor: "primary.darker",
                maxHeight: 55,
                fillRow: true,
                paddingLeft: 0,
                paddingRight: 8
            },
            titleProps: {
                color: "default.reverse",
                fontBold: true,
                fontSize: "large",
                imageColor: "primary.light",
                imageName: ImageName.circleX,
                rowBreak: false,
                marginLeft: 16
            }
        });

        this._codeType = codeType;
        this.buttonClose.setProps({
            color: "primary.reverse"
        });
    }

    override async show(): Promise<any> {
        this.layout = Layout.getLayout("lme/dispatch/UnassignPrompt") as UnassignPrompt;
        this.layout.addLayoutLoadListener(() => {
            this.layout.mainDataSource.mode = DataSourceMode.ADD;

            this.layout.textboxReasonCode.addBeforeLookupModelSearchListener((event) => {
                event.filter.code_type = this._codeType;
            });

            this.layout.buttonNo.addClickListener(() => this.close(false));
            this.layout.buttonYes.addClickListener(() => {
                if (this.layout.mainDataSource.validate()) {
                    this.close(this.layout.activeRow);
                }
            });
        });

        this.add(this.layout);
        return super.show();
    }
}
